// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const Diagnostics = () => ({
   replace: true,
   templateUrl: '/assets/diagnostics/diagnostics.html',
   controller: 'DiagnosticsCtrl',

   scope: {
      diagnostics: '=?',
      parentKey: '=?',
      key: '=?'
   }
})

// A container is required to avoid Angular directive recursion loop
const DiagnosticsContainer = ($compile: any) => ({
   replace: true,

   scope: {
      diagnosticsContainer: '=',
      parentKey: '=',
      key: '='
   },

   template: "<div></div>",

   link(scope: any, element: any){
      element.append("<div diagnostics='diagnosticsContainer' parent-key='parentKey' key='key'></div>")
      return $compile(element.contents())(scope)
   }
})

angular.module('summonApp.directives')
   .directive('diagnostics', Diagnostics)
   .directive('diagnosticsContainer', ['$compile', DiagnosticsContainer])
